import { useNavigate } from 'react-router-dom';

import { AppIcon, PageHeader } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, Button, SxProps, Theme, TextField } from '@mui/material';

const BOOKMARK_STRINGS = appStrings.modules.bookmarks;

type BookmarkHeaderProps = Readonly<{
  searchTerm: string;
  onSearchTermChange: (value: string) => void;
}>;

export const BookmarkHeader = ({ searchTerm, onSearchTermChange }: BookmarkHeaderProps) => {
  const navigate = useNavigate();

  return (
    <PageHeader
      title={BOOKMARK_STRINGS.header.title}
      subtitle={BOOKMARK_STRINGS.header.subtitle}
      maxWidth={null}
      rightComponents={[
        <Box key="right-components-container" sx={rightComponentsContainerSx}>
          <Box key="buttons-container" sx={buttonsContainerSx}>
            <Button
              id="bookmarks-playbooks-button"
              key="playbooks"
              hierarchy="Secondary gray"
              size="md"
              startIcon={<AppIcon iconName="ClipboardPlus" color="Gray/700" diameter="16px" />}
              sx={playbooksButtonSx}
              onClick={() => navigate(`${APP_ROUTE.PRIORITIES}`)}
            >
              {appStrings.common.navigation.myPlaybooks}
            </Button>
          </Box>
          <TextField
            id="bookmarks-search-input"
            key="search-field"
            variant="outlined"
            placeholder="Search bookmarks"
            value={searchTerm}
            onChange={(event) => onSearchTermChange(event.target.value)}
            InputProps={{
              startAdornment: <AppIcon iconName="SearchMd" color="currentColor" diameter="20px" />,
            }}
            sx={searchBarSx}
          />
        </Box>,
      ]}
    />
  );
};

const searchBarSx: SxProps<Theme> = ({ backrs }) => ({
  width: '100%',
  '@container (min-width: 600px)': {
    width: '300px',
  },
  maxWidth: '320px',
  backgroundColor: backrs.colors['Colors/Base/White'],
  marginBottom: backrs.spacing['spacing-lg'],
  '& .MuiInputBase-root': {
    height: '40px',
    border: `1px solid ${backrs.colors['Gray/600']}`,
  },
});

const playbooksButtonSx: SxProps<Theme> = ({ backrs }) => ({
  alignSelf: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  border: `1px solid ${backrs.colors['Gray/600']}`,
  height: '40px',
  whiteSpace: 'nowrap',
});

const buttonsContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  gap: backrs.spacing['spacing-none'],
  flexDirection: 'column',
  '@container (min-width: 600px)': {
    flexDirection: 'row',
  },
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
});

const rightComponentsContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  '@container (min-width: 700px)': {
    flexDirection: 'row',
  },
  columnGap: backrs.spacing['spacing-lg'],
  rowGap: backrs.spacing['spacing-sm'],
  alignItems: 'flex-start',
});
